<template>
  <div class="zhezhao">
    <div class="content">
      <div class="header">
        <div class="back" @click="closeSecond">
          <i class="el-icon-arrow-left"></i>
          <span>Back</span>
        </div>
      </div>
      <div class="tips">
        <a-icon type="exclamation-circle" />
        <span class="tip"
          >US business owners supported currently, more countries will be open
          soon. The application terms require you to have a corporate and
          corporate bank account.</span
        >
      </div>
      <div class="title">Apply for a net-terms of 60 days</div>
      <!-- <div class="desc">
        Can’t link your bank?You can choose to manually review the application
        terms, and we will verify it within one day.
      </div> -->
      <div class="desc">
        Manually apply for terms. The application pass rate is relatively high, and it is reviewed in about a day.
      </div>
      <div class="btn" @click="openThird">
        <img src="@/assets/EIN-1x.png" />Manual review application for net 60 terms
      </div>

      <!-- <div class="desc">
        Link your bank in a few quick steps to pay with terms on shopvidi We use
        a secure flow to help you link your bank account. This gives us accurate
        information we can use to approve you for terms.
      </div>
      <div class="btn" @click="getBankAudit">
        Link your bank to apply for net 60 terms
      </div> -->
    </div>
  </div>
</template>
<script>
import { bankAudit } from '@/api/creditPayment.js'

export default {
  data() {
    return {
    }
  },
  props: {
    onInterval: {
      type: Function,
      default: () => {}
    }

  },
  methods: {
    closeSecond() {
      this.$emit('closeSecond', '')
    },
    openThird() {
      this.$emit('openThird', 'third')
    },
    // 银行自动审核
    getBankAudit() {
      console.log(bankAudit, '方法')
      console.log('123')
      let newTab = window.open()
      bankAudit('/balance/apply/cards').then((res) => {
        console.log(res, '银行审核')
        if (res.code == 200 && res.success) {
          let url = res.result
          if (url) {
            // this.onInterval() haoyuanw add  2021-10-15 这里注释上，需要手动启动 定时查询
            newTab.location.href = url
            // 银行受理的话，只要点击该按钮的话，就需要将整个页面进行loading，并且将银行授信的标致通过父组件，传递到子组件verifyDialog来动态显示信息。调用一个父组件方法即可
            this.$emit('handleBank', 'true')
          }
        } else {
          this.$message({
            message: res.message || 'No Link',
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.zhezhao {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100vw;
  height: 100vh;
  background: rgba(52, 52, 52, 0.3);
  .content {
    background: #ffffff;
    width: 600px;
    padding: 36px;
    .header {
      // padding: 26px 0;
      .back {
        font-size: 18px;
        cursor: pointer;
      }
    }
    .tips {
      font-size: 14px;
      color: #f77073;
      margin-top: 20px;
    }
    .title {
      display: flex;
      justify-content: center;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #262b2f;
      margin-top: 20px;
    }
    .desc {
      font-size: 14px;
      font-family: Graphik;
      font-weight: 500;
      color: #262b2f;
      margin-top: 40px;
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 56px;
      background: #262b2f;
      border-radius: 5px;
      font-size: 18px;
      font-family: Graphik;
      color: #ffffff;
      margin-top: 30px;
      cursor: pointer;
    }
  }
}
@media screen and (max-width: 420px) {
  .zhezhao {
    width: 100vw;
    height: 100vh;
    .content {
      width: calc(100vw - 90px);
      .title {
        font-size: 16px;
      }
      .desc {
        margin-top: 20px;
      }
      .btn {
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/credit-payment/creditDialog.vue